import api from './api/api';

/**
 * Tutorial Service
 * Handles all API calls related to tutorial preferences and usage
 */
class TutorialService {
	/**
	 * Get all tutorial data for the current user
	 */
	async getTutorialData() {
		try {
			const response = await api.get('api/tutorial');
			return response;
		} catch (error) {
			console.error('Error getting tutorial data:', error);
			return {
				success: false,
				error: error.message,
				data: {
					preferences: {},
					usageCounts: {}
				}
			};
		}
	}

	/**
	 * Get preference for a specific feature
	 */
	async getFeaturePreference(featureId) {
		try {
			const response = await api.get(`api/tutorial/preference/${featureId}`);
			return response?.data?.preference || null;
		} catch (error) {
			console.error('Error getting feature preference:', error);
			return null;
		}
	}

	/**
	 * Set preference for a feature
	 */
	async setFeaturePreference(featureId, preference) {
		try {
			const response = await api.post('api/tutorial/preference', {
				featureId,
				preference
			});
			return response;
		} catch (error) {
			console.error('Error setting feature preference:', error);
			return {
				success: false,
				error: error.message
			};
		}
	}

	/**
	 * Get usage count for a feature
	 */
	async getFeatureUsageCount(featureId) {
		try {
			const response = await api.get(`api/tutorial/usage/${featureId}`);
			return response?.data?.usageCount || 0;
		} catch (error) {
			console.error('Error getting feature usage count:', error);
			return 0;
		}
	}

	/**
	 * Increment usage count for a feature
	 */
	async incrementFeatureUsage(featureId) {
		try {
			const response = await api.post('api/tutorial/usage', { featureId });
			return response;
		} catch (error) {
			console.error('Error incrementing feature usage:', error);
			return {
				success: false,
				error: error.message
			};
		}
	}

	/**
	 * Check if tutorial should be shown for a feature
	 */
	async shouldShowTutorial(featureId) {
		try {
			const response = await api.get(`api/tutorial/should-show/${featureId}`);
			return response?.data?.shouldShow ?? true;
		} catch (error) {
			console.error('Error checking if tutorial should be shown:', error);
			// Default to showing tutorial on error
			return true;
		}
	}

	/**
	 * Update multiple preferences at once
	 */
	async updatePreferences(preferences) {
		try {
			const response = await api.put('api/tutorial/preferences', { preferences });
			return response;
		} catch (error) {
			console.error('Error updating preferences:', error);
			return {
				success: false,
				error: error.message
			};
		}
	}
}

const tutorialService = new TutorialService();
export default tutorialService;

